import dayjs from "dayjs";

export const LsqmTableHeader=[
    { field: 'sl_no', headerName: 'Sl No', width: 80 },
    { field: 'userName', headerName: 'OGA Name', width: 250 },
    { field: 'lsUserId', headerName: 'Leadsquared ID', width: 340 },
    { field: 'lsEmail', headerName: 'Leadsquared Email ', width: 250 },
    { field: 'createdByName', headerName: 'Created By', width: 250 },
    { field: 'createdOn', headerName: 'Created On', width: 190,
        renderCell:({row})=>{
            return dayjs(row.createdOn).format('MM/DD/YYYY hh:mm A');
        }
     },
]